import FileTypeIcon from './file-type-icon'

export type { FileTypeIconProps } from './file-type-icon'

export default FileTypeIcon
